<script setup>
import { ref } from "vue";
import LayoutFooter from "@/components/layout/layoutFooter.vue";
import layoutShell from "@/components/layout/layoutShell.vue";
import compWorkflow from "@/components/siem/compWorkflowTable.vue";
import compWorkflowsStatsPanel from "@/components/siem/compWorkflowsStatsPanel.vue";

const tableRef     = ref(null);
const tableFilters = ref({});
</script>
<template>
  <!-- Sidebar -->
  <layoutShell>
    <div class="layout-content-wrapper">
      <main class="content">
        <!-- Table first in source order → full width on top for small screens -->
        <div class="grid">
          <div class="col-12 xl:col-9">
            <compWorkflow ref="tableRef" @filters-change="f => tableFilters = f" />
          </div>
          <div class="col-12 xl:col-3">
            <compWorkflowsStatsPanel
              :active-filters="tableFilters"
              @filter="f => tableRef?.applyExternalFilter(f)"
            />
          </div>
        </div>
      </main>
    </div>
    <div class="layout-footer">
      <LayoutFooter />
    </div>
  </layoutShell>
</template>
